import React, { useCallback, useState } from 'react';
import api from '../../../services/api';
import {
  Container,
  Form,
  CheckboxLabel,
  Button,
  PrivacyText,
  Input,
  InputContainer,
  TooltipError,
} from './styles';

interface Props {
  resultId: number;
  code: string;
  imageBase64: string | null;
  captureBubbleTreeImage: () => Promise<string | null>;
}

const TsoSelbtestResults: React.FC<Props> = ({
  resultId,
  code,
  imageBase64,
  captureBubbleTreeImage,
}): JSX.Element => {
  const [email, setEmail] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [subscribeToTips, setSubscribeToTips] = useState(false);
  const [optionalCheckbox, setOptionalCheckbox] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [invalidMailError, setInvalidMailError] = useState('');
  const [invalidCustomerNameError, setInvalidCustomerNameError] = useState('');
  const [localImage, setLocalImage] = useState<string | null>(imageBase64);

  const validateEmail = (inputEmail: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(inputEmail);
  };

  const handleButtonSendMail = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();

      if (!validateEmail(email)) {
        setInvalidMailError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
        return;
      }

      if (customerName === '') {
        setInvalidCustomerNameError('Bitte geben Sie Ihren Namen ein.');
      }

      setInvalidMailError('');

      let imageToSend = localImage;
      if (!localImage) {
        imageToSend = await captureBubbleTreeImage();
        setLocalImage(imageToSend);
      }

      if (!imageToSend) {
        setError(
          'Fehler beim Generieren des Bildes. Bitte versuchen Sie es erneut.',
        );
        return;
      }

      const respondent = {
        email,
        customerName,
        resultId,
        code,
        reportAcceptance: subscribeToTips,
        newsletterAcceptance: false,
        imageChartResults: imageToSend.split(',')[1]?.trim(),
        chartType: 'tso',
      };

      try {
        await api.post('/respondents', respondent);
        setSubmitted(true);
      } catch (err) {
        console.error('Erro ao enviar e-mail:', err);
        setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
      }
    },
    [
      captureBubbleTreeImage,
      code,
      customerName,
      email,
      localImage,
      resultId,
      subscribeToTips,
    ],
  );

  return (
    <Container>
      {!submitted && (
        <div style={{ marginBottom: '20px' }}>
          <div>
            <span
              style={{
                marginBottom: '20px',
                fontSize: '24px',
                lineHeight: '42px',
              }}
            >
              Gib deine{' '}
              <span style={{ color: '#980000' }}>E-Mail-Adresse </span> ein, und
              wir senden dir dein persönliches Ergebnis direkt in dein Postfach:
            </span>
          </div>
        </div>
      )}
      {!submitted ? (
        <Form onSubmit={handleButtonSendMail}>
          <InputContainer>
            <Input
              type="customerName"
              placeholder="Dein Name"
              value={customerName}
              onChange={e => setCustomerName(e.target.value)}
              required
            />
            {invalidMailError && (
              <TooltipError $left="40%">
                <span>{invalidCustomerNameError}</span>
              </TooltipError>
            )}
          </InputContainer>

          <InputContainer>
            <Input
              type="email"
              placeholder="E-Mail-Adresse"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            {invalidMailError && (
              <TooltipError $left="40%">
                <span>{invalidMailError}</span>
              </TooltipError>
            )}
          </InputContainer>
          {error && <span className="error">{error}</span>}

          <div style={{ marginBottom: '15px', marginTop: '20px' }}>
            <CheckboxLabel>
              <input
                type="checkbox"
                checked={subscribeToTips}
                onChange={() => setSubscribeToTips(!subscribeToTips)}
                style={{ marginRight: '10px' }}
              />
              Ich habe die
              <a
                href="https://www.top-service-oesterreich.at/datenschutzerklaerung/"
                target="_blank"
                rel="noreferrer"
                style={{ marginLeft: '5px', marginRight: '5px' }}
              >
                <u>
                  <b>Datenschutzerklärung</b>
                </u>
              </a>
              gelesen und akzeptiere sie.
            </CheckboxLabel>

            <CheckboxLabel>
              <input
                type="checkbox"
                checked={optionalCheckbox}
                onChange={() => setOptionalCheckbox(!optionalCheckbox)}
                style={{ marginRight: '10px' }}
              />
              Ja, ich möchte den Newsletter mit topaktuellen Insights zu
              Kundenorientierung und Unternehmenskultur erhalten. Eine Abmeldung
              ist jederzeit möglich.
            </CheckboxLabel>
          </div>

          <PrivacyText>
            Durch die Übermittlung meiner personenbezogenen Daten willige ich
            ein, dass meine Daten in Übereinstimmung mit der{' '}
            <a
              href="https://www.top-service-oesterreich.at/datenschutzerklaerung/"
              target="_blank"
              rel="noreferrer"
            >
              <u>
                <b>Datenschutzerklärung</b>
              </u>
            </a>{' '}
            erhoben, verarbeitet und gespeichert werden.
          </PrivacyText>

          <Button type="submit" disabled={!subscribeToTips}>
            Ergebnis erhalten
          </Button>
        </Form>
      ) : (
        <div
          style={{
            marginBottom: '20px',
            marginTop: '-50px',
            marginLeft: '90px',
          }}
        ></div>
      )}
    </Container>
  );
};

export default TsoSelbtestResults;
